import authService from '../services/authService';
import alertActions from './alertActions';

const authActions = {
	login(user, pass) {
		return async dispatch => {
			try {
				dispatch({ type: 'LOGIN_REQUEST' });
				await authService.authenticate(user, pass);
				dispatch({ type: 'LOGIN_SUCCESS' });
			}
			catch (err) {
				dispatch({ type: 'LOGIN_FAILURE', err });
				dispatch(alertActions.error(err.message));
			}
		}
	},

	logout() {
		return dispatch => {
			if (!!localStorage.getItem('user')) {
				authService.destroy();
				dispatch(alertActions.success('You have been logged out.'));
				dispatch({ type: 'LOGOUT' });
			}
		}
	}
}

export default authActions;



// WEBPACK FOOTER //
// ./src/actions/authActions.js